export default {
      id: "btn-save-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#btn-save",
      toString: function () {
        return this.url;
      }
    }